// extracted by mini-css-extract-plugin
export var menuIcon = "_ri-0";
export var menuIconInline = "_ri-1";